import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MainComponent } from './containers/main/main.component';
import { SharedModule } from '@shared';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MAEffects } from './store/ma.effects';
import { reducer } from './store/ma.reducer';
import { MaService } from './services/ma.service';
import { DoughnutChartComponent } from './components/doughnut-chart/doughnut-chart.component';
import { AccountStatsComponent } from './components/account-stats/account-stats.component';
import { HeaderComponent } from './components/header/header.component';
import { CardComponent } from './components/card/card.component';
import { BootstrapModalComponent } from './components/bootstrap-modal/bootstrap-modal.component';
import { ChartComponent } from './components/chart/chart.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ChartBlockComponent } from './components/chart-block/chart-block.component';
import { FlowCheckComponent } from './components/flow-check/flow-check.component';

@NgModule({
  declarations: [
    MainComponent,
    DoughnutChartComponent,
    AccountStatsComponent,
    HeaderComponent,
    DoughnutChartComponent,
    CardComponent,
    BootstrapModalComponent,
    ChartComponent,
    ChartBlockComponent,
    FlowCheckComponent,
  ],
  providers: [MaService],
  imports: [
    CommonModule,
    NgbModule,
    SharedModule,
    StoreModule.forFeature('MA', reducer),
    EffectsModule.forFeature([MAEffects]),
    NgbModule,
    ReactiveFormsModule,
  ],
})
export class MaModule {}
